export function useMobile() {
  if (typeof window !== 'undefined' && window.innerWidth < 768) return true;
  return false;
}
